import React, { Component } from "react"
import Slider from "react-slick"
import { motion } from "framer-motion"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons"

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./testimonials.css"

import img1 from "../../images/test5.jpeg"
import img2 from "../../images/test1.jpeg"
import img3 from "../../images/test6.jpeg"
import img4 from "../../images/test7.jpeg"
import img5 from "../../images/test8.jpeg"
import img6 from "../../images/test9.jpeg"

const photos = [
  {
    quote:
      "Jon loves to play the piano. After a few weeks with Codehall, I asked Jon whether he enjoys the piano or coding more, and he said coding! Thank you so much for giving him something fun and important to do this summer!",
    author: "Trudy F.",
    img: img1,
    role: "Parent",
  },
  {
    quote:
      "Matthew is absolutely loving the camp. He really likes collaborating with his friend and doing the worksheets together!",
    author: "Juliana N.",
    img: img2,
    role: "Parent",
  },
  {
    quote:
      "I learned so much during the first few weeks, and it was so much fun! Coding is my new favorite subject now!",
    author: "Aislin S.",
    img: img4,
    role: "Member - Age 13",
  },
  {
    quote:
      "I would just like to thank you guys for the great first week of coding that Rama had. He really enjoys it, which I’m super happy about as I think it’s an amazing life skill to have.",
    author: "Caroline V.",
    img: img3,
    role: "Parent",
  },
  {
    quote:
      "In 2 weeks I was able to learn the fundamentals of coding, and I surprisingly enjoyed it so much!",
    author: "Jaden A.",
    img: img5,
    role: "Student",
  },
  {
    quote:
      "I coded in school for a little while and I never resonated with it. I thought it was too lectury and I never thought I could actually create cool stuff with it.",
    author: "Alex R.",
    img: img6,
    role: "Student",
  },
]

export default class extends Component {
  render() {
    const settings = {
      dots: true,
      pauseOnHover: true,
      dotsClass: "slick-dots",
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      arrows: false,
      slidesToScroll: 1,
      className: "testimonials",
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: false,

      responsive: [
        {
          breakpoint: 600,
          settings: {
            autoplaySpeed: 3000,
            slidesToShow: 3,
            centerMode: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            centerMode: false,
            autoplaySpeed: 3000,
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 320,
          settings: {
            centerMode: false,

            slidesToShow: 1,
          },
        },
      ],
    }
    return (
      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          visible: { opacity: 1, y: 0 },
          hidden: { opacity: 0, y: 20 },
        }}
        transition={{ ease: "easeOut", duration: 0.8, delay: 1.5 }}
        className="tests"
      >
        <div className="programs-title">
      <h2>{this.props.forParents ? 'Skip Fortnite, Start Coding' : 'Kids and parents love us'}</h2>
        </div>
        <Slider {...settings}>
          {photos.map((photo, index) => {
            return (
                <div key={`${index}-${photo.author}`} className="testimonial">
                  <div className="testimonial-inner">
                    <div className="testimonial-icon">
                      <FontAwesomeIcon
                        icon={faQuoteLeft}
                        size="3x"
                        style={{
                          color:
                            photo.role === "Parent" ? "#745bff" : "#fd8e86",
                        }}
                      />
                    </div>
                    <div className="testimonial-quote">{photo.quote}</div>
                    <div className="testimonial-footer">
                      <div className="testimonial-author">
                        <div className="">
                          <img
                            className="testimonial-author-photo"
                            src={photo.img}
                            alt={`${photo.author}`}
                          />
                        </div>
                        <div className="testimonial-author-details">
                          <div className="testimonial-author-name">
                            {photo.author}
                          </div>
                          <div className="testimonial-author-role">
                            {photo.role}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            )
          })}
        </Slider>
      </motion.div>
    )
  }
}
